import React from 'react';
import Reflux from 'reflux';

import CuesheetTrackingStore from 'flux/stores/cuesheet/CuesheetTrackingStore';
import CuesheetTrackingActions from 'flux/actions/cuesheet/CuesheetTrackingActions';

import { Icon } from '@shoflo-rundown/polymer.legacy';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';

/**
 * A component for allowing a show caller to stop broadcasting their tracking position
 *
 */
export default React.createClass({
  displayName: 'TrackingStopBroadcastButton',

  mixins: [
    Reflux.connectFilter(CuesheetTrackingStore, 'enabled', (state) =>
      state.get('trackingResumeAvailable'),
    ),
  ],

  render() {
    let enabled = this.state.enabled;
    if (!enabled) return <span />;

    return (
      <a className="cs-tracking-stop-link" onClick={this._handleClick}>
        <WithTooltip
          placement="top"
          delay={500}
          tip={TooltipConstants.CSStopBroadcastingTrackingLink}
        >
          <Icon className="cs-tracking-stop-icon" name="bullhorn" />
        </WithTooltip>
      </a>
    );
  },

  _handleClick() {
    CuesheetTrackingActions.clearTrackableCue();
  },
});
